import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import CopyButton from './CopyButton';
import './IssuedValue.css';

// A VALUE THE PLATFORM ISSUED, SHOWN TO BE HANDED OVER.
//
// An MCP instance's endpoint, client id and client secret are generated for the customer and then have
// to reach whoever configures the model. So the one thing this control must do well is be copied
// exactly — a value that is read off a screen and retyped is a support ticket waiting for its first
// transposed character.
//
// NOT AN INPUT. A disabled text box says "you may not change this yet"; this says "this is not yours to
// change". It also stops the value being selected, half-copied and silently truncated at the box's
// width, which is what a long client secret in a narrow field invites.
//
// A SECRET IS HIDDEN UNTIL ASKED FOR, and can still be copied while hidden — the clipboard is how it
// should travel anyway, and revealing it is for the person who wants to check what they pasted.
const IssuedValue = ({ value, secret = false }) => {
    const [shown, setShown] = useState(!secret);
    return (
        <span className="iv">
            <code className={`iv-value${secret && !shown ? ' iv-masked' : ''}`}>
                {secret && !shown ? '•'.repeat(Math.min(String(value).length, 40)) : value}
            </code>
            {secret && (
                <button
                    type="button"
                    className="iv-btn"
                    onClick={() => setShown(s => !s)}
                    title={shown ? 'Hide' : 'Show'}
                    aria-label={shown ? 'Hide the value' : 'Show the value'}
                >
                    {shown ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
            )}
            <CopyButton value={value} />
        </span>
    );
};

export default IssuedValue;
